import React, { useEffect } from "react";
import logo from "../../assets/img/Logo/logo.svg";
import home from "../../assets/img/icons/sidebarmenu/home-2.png";
import wallet from "../../assets/img/icons/sidebarmenu/wallet-2.png";
import wishlist from "../../assets/img/icons/sidebarmenu/heart.png";
import editprofile from "../../assets/img/icons/sidebarmenu/user-edit.svg";
import statics from "../../assets/img/icons/sidebarmenu/graph.svg";
import addres from "../../assets/img/icons/sidebarmenu/add-square.svg";
import reserve from "../../assets/img/icons/sidebarmenu/reserve.svg";
import mytrips from "../../assets/img/icons/sidebarmenu/shopping-bag.svg";
import addblog from "../../assets/img/icons/sidebarmenu/note-add.svg";
import publishedblog from "../../assets/img/icons/sidebarmenu/document-text.svg";
import comments from "../../assets/img/icons/sidebarmenu/messages-2.svg";
import close from "../../assets/img/icons/close-square.svg";
import edit from "../../assets/img/icons/sidebarmenu/edit-2.svg";
import { Link, useNavigate } from "react-router-dom";
import profile from "../../assets/img/Home/profile.png";
import logout from "../../assets/img/icons/sidebarmenu/login.svg";
import {useUserInfo} from "../../context/UserContext"
import useFetch from "../../hooks/useAxios";
import { useAuth } from "../../context/authContext";
import toast from "react-hot-toast";
const ResponsiveUserSidebar = ({setShow}) => {
  const GuestList = [
    {
      url: "/user/",
      title: "پیشخوان من",
      img: home
    },
    {
      url: "/user/wallet",
      title: "کیف پول من",
      img: wallet
    },
    {
      url: "/user/wishlist",
      title: "علاقه مندی ها",
      img: wishlist
    },
    {
      url: "/user/editprofile",
      title: "تغیر مشخصات پروفایل",
      img: editprofile
    },
  
    {
      url: "/user/mytrips",
      title: "سفر های من",
      img: mytrips
    },
    {
      url: "/user/addblog",
      title: "افزودن مقاله",
      img: addblog
    },
    {
      url: "/user/publishedblog",
      title: "مقالات منتشر شده",
      img: publishedblog
    },
    {
      url: "/user/comments",
      title: "دیدگاه ها",
      img: comments
    }
  ];
  const AdminList = [
    {
      url: "/user/",
      title: "پیشخوان من",
      img: home
    },
    {
      url: "/user/wallet",
      title: "کیف پول من",
      img: wallet
    },
    {
      url: "/user/wishlist",
      title: "علاقه مندی ها",
      img: wishlist
    },
    {
      url: "/user/editprofile",
      title: "تغیر مشخصات پروفایل",
      img: editprofile
    },
    {
      url: "/user/statics",
      title: "آمار میزبانی",
      img: statics
    },
    {
      url: "/create",
      title: "افزودن اقامتگاه",
      img: addres
    },
    {
      url: "/user/reserve",
      title: "رزرو های اقامتگاه من",
      img: reserve
    },
    {
      url: "/user/mytrips",
      title: "سفر های من",
      img: mytrips
    },
    {
      url: "/user/addblog",
      title: "افزودن مقاله",
      img: addblog
    },
    {
      url: "/user/publishedblog",
      title: "مقالات منتشر شده",
      img: publishedblog
    },
    {
      url: "/user/comments",
      title: "دیدگاه ها",
      img: comments
    },
   
  ];
  const { authDispatch, authRefreshDispatch } = useAuth();

  const {userinfo}=useUserInfo()
 const navigate = useNavigate()
 const logoutFetch = useFetch({
  method: "post",
  url: "api/logout",
  noHeader: false,
  trigger: false,
 
  argFunc: res => {
    authDispatch({
      type: "LOGOUT"
     
    });
    toast.success("شما با موفقیت از حساب کاربری خود خارج شدید.")
    navigate("/")
  }
});
const goToPage = (url)=>{
    setShow(false)
    navigate(`user${url}`)
}

   return (
    <div className="UserPanelSidebar UserPanelSidebar-responsive">
        <button onClick={()=>setShow(false)} className=" absolute left-1 top-1"><img src={close}/> </button>
      <div>
        <Link to="/">
          <img src={logo} />
        </Link>
      </div>
      <div>
      <div className="userProfile ">
        <div className="relative" >
          <img src={userinfo.data.user.avatar}className="profile-img " />
          <div className="userProfile-editbox center cursor-pointer" onClick={()=>navigate("/user/editprofile")}  >
            <img src={edit} />
          </div>
        </div>
        <h6>{userinfo.data.user.full_name}</h6>
        <p>{userinfo.data.user.phone}</p>
      </div>
      <ul className="flex flex-col">
        {userinfo.data.user.role === "مهمان" ? GuestList.map(i =>
          <button onClick={()=>goToPage(i.url)}>
            <li className="flex gap-[15px] items-center">
              <img src={i.img} /> <span>{i.title}</span>{" "}
            </li>
          </button>
        ) :  AdminList.map(i =>
          <button onClick={()=>goToPage(i.url)}>
            <li className="flex gap-[15px] items-center">
              <img src={i.img} /> <span>{i.title}</span>{" "}
            </li>
          </button>
        ) }
      </ul>
      </div>
      <div className="UserPanelSidebar__logout flex gap-[15px] items-center cursor-pointer" onClick={()=>logoutFetch.reFetch()}>
        <img src={logout} />

        <p>خروج از حساب کاربری</p>
      </div>
    </div>
  );
};



export default ResponsiveUserSidebar